<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="bg-white rounded-lg py-3 mb-6">
    <div class="flex justify-between items-center mt-3 mb-6 px-6">
      <h1>
        {{
          isEditMode
            ? ("employee.edit" | translate)
            : ("employee.add" | translate)
        }}
      </h1>
      <app-primary-button
        class="text-sm text-blue-600 hover:underline"
        routerLink="/home/employees"
      >
        ← {{ "BACK" | translate }}
      </app-primary-button>
    </div>

    <div class="user-group grid grid-cols-12 border-t-2 pt-4 px-6 gap-8">
      <div class="col-span-4" *ngIf="branchShow">
        <mat-label
          >{{ "employee.branch" | translate }}
          <span class="red">*</span></mat-label
        >
        <mat-form-field appearance="outline">
          <mat-select formControlName="branch_id">
            <mat-option value="">{{
              "employee.select_branch" | translate
            }}</mat-option>
            <mat-option
              *ngFor="let branch of branchList"
              [value]="branch.branch_id"
              >{{ branch.branch_name }}</mat-option
            >
          </mat-select>
          <mat-error *ngIf="submitted && f['branch_id'].errors?.['required']">
            {{ "error.branch_required" | translate }}</mat-error
          >
        </mat-form-field>
      </div>

      <div class="col-span-4">
        <mat-label>{{ "employee.full_name" | translate }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="full_name"
            [ngClass]="{ 'is-invalid': submitted && f['full_name'].errors }"
          />
          <mat-error *ngIf="submitted && f['full_name'].errors?.['required']">{{
            "error.full_name_required" | translate
          }}</mat-error>
        </mat-form-field>
      </div>
      <div class="col-span-4">
        <mat-label>{{ "employee.contact_email" | translate }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="emailId"
            [ngClass]="{ 'is-invalid': submitted && f['emailId'].errors }"
          />
          <mat-error
            *ngIf="submitted && f['emailId'].errors?.['required']"
            >{{ "error.required" | translate }}</mat-error
          >
        </mat-form-field>
      </div>

      <div class="col-span-4">
        <mat-label> {{ "employee.contact_phone" | translate }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="contact_phone"
            [ngClass]="{ 'is-invalid': submitted && f['contact_phone'].errors }"
          />
          <mat-error
            *ngIf="submitted && f['contact_phone'].errors?.['required']"
            >{{ "error.required" | translate }}</mat-error
          >
        </mat-form-field>
      </div>
   
  

  

      <div class="col-span-4" *ngIf="isEditMode == true">
        <mat-label> {{ "employeeId" | translate }}(Company Id)</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="employeeId"
            [ngClass]="{ 'is-invalid': submitted && f['employeeId'].errors }" readonly
          />
          <mat-error
            *ngIf="submitted && f['employeeId'].errors?.['required']"
            >{{ "error.required" | translate }}</mat-error
          >
        </mat-form-field>
      </div>
        <div class="col-span-4">
        <mat-label>{{
          "employee.employment_start_date" | translate
        }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            [matDatepicker]="startPicker"
            formControlName="employmentStartDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="startPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <!-- <div class="col-span-4">
        <mat-label>{{ "employee.email_id" | translate }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="emailId"
            [ngClass]="{ 'is-invalid': submitted && f['emailId'].errors }"
          />
          <mat-error *ngIf="submitted && f['emailId'].errors?.['required']">{{
            "error.required" | translate
          }}</mat-error>
        </mat-form-field>
      </div> -->

    
        <div class="col-span-4">
        <mat-label> {{ "employee.department" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="department"
            [ngClass]="{ 'is-invalid': submitted && f['department'].errors }"
          />
          <mat-error
            *ngIf="submitted && f['department'].errors?.['required']"
            >{{ "error.required" | translate }}</mat-error
          >
        </mat-form-field>
      </div>

      <div class="col-span-4">
        <mat-label>{{ "employee.designation" | translate }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input matInput formControlName="designation" />
        </mat-form-field>
      </div>
        <div class="col-span-4" >
        <mat-label>Employee ID(Software)</mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="employeeNumber"
            [ngClass]="{
              'is-invalid': submitted && f['employeeNumber'].errors
            }"
          />
          <mat-error
            *ngIf="submitted && f['employeeNumber'].errors?.['required']"
            >{{ "error.required" | translate }}</mat-error
          >
        </mat-form-field>
      </div>
         <!-- <div class="col-span-4">
        <mat-label>{{ "employee.domain" | translate }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <mat-select formControlName="domain" required>
        
            <mat-option value=""
              >Select {{ "employee.domain" | translate }}</mat-option
            >
            <mat-option value="Consultancy">Consultancy</mat-option>
            <mat-option value="Commercial">Commercial</mat-option>
            <mat-option value="Road">Road</mat-option>
            <mat-option value="Utilities">Utilities</mat-option>
          </mat-select>
          <mat-error *ngIf="submitted && f['domain'].errors?.['required']">{{
            "error.required" | translate
          }}</mat-error>
        </mat-form-field>
      </div> -->
      
          <div class="col-span-4">
        <mat-label>{{ "org_type" | translate }}</mat-label>

        <mat-form-field class="w-full" appearance="outline">
          <mat-select
            formControlName="roleId"
            (selectionChange)="onRoleChange($event.value)"
            required
            [ngClass]="{ 'is-invalid': submitted && f['roleId'].errors }"
          >
            <mat-option value=""
              >Select {{ "org_type" | translate }}</mat-option
            >
            <mat-option *ngFor="let role of organizations" [value]="role.id">{{
              role.value
            }}</mat-option>
          </mat-select>
          <mat-error *ngIf="submitted && f['roleId'].errors?.['required']">
            {{ "error.role_required" | translate }}</mat-error
          >
        </mat-form-field>
      </div>
      <div class="col-span-4">
        <mat-label> {{ "employee.role_in_software" | translate }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <mat-select
            formControlName="roleInSoftware"
            [ngClass]="{
              'is-invalid': submitted && f['roleInSoftware'].errors
            }"
          >
            <mat-option value=""
              >Select {{ "employee.role_in_software" | translate }}</mat-option
            >
            <mat-option *ngFor="let role of designationList" [value]="role">{{
              role
            }}</mat-option>
          </mat-select>
          <mat-error
            *ngIf="submitted && f['roleInSoftware'].errors?.['required']"
            >{{ "error.required" | translate }}</mat-error
          >
        </mat-form-field>
      </div>
      <div *ngIf="false" class="col-span-4">
        <mat-label>{{
          "employee.membership_start_date" | translate
        }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            [matDatepicker]="memStartPicker"
            formControlName="membershipStartDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="memStartPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #memStartPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div *ngIf="false" class="col-span-4">
        <mat-label>{{ "employee.membership_end_date" | translate }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            [matDatepicker]="memEndPicker"
            formControlName="membershipEndDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="memEndPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #memEndPicker></mat-datepicker>
        </mat-form-field>
      </div>
    

      <div class="col-span-4">
        <mat-label> {{ "employee.state" | translate }}</mat-label>

        <mat-form-field appearance="outline" class="half-width">
          <mat-select
            formControlName="state"
            (selectionChange)="onStateChange()"
            required
            [ngClass]="{ 'is-invalid': submitted && f['state'].errors }"
          >
            <mat-option value="">Select State</mat-option>

            <mat-option *ngFor="let state of states" [value]="state">{{
              state
            }}</mat-option>
          </mat-select>
          <mat-error *ngIf="submitted && f['state'].errors?.['required']">{{
            "error.required" | translate
          }}</mat-error>
        </mat-form-field>
      </div>
      <div class="col-span-4">
        <mat-label> {{ "employee.city" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="half-width">
          <mat-select
            formControlName="city"
            required
            [ngClass]="{ 'is-invalid': submitted && f['city'].errors }"
          >
            <mat-option value="">Select City</mat-option>
            <mat-option *ngFor="let city of cities" [value]="city">{{
              city
            }}</mat-option>
          </mat-select>
          <mat-error *ngIf="submitted && f['city'].errors?.['required']">{{
            "error.required" | translate
          }}</mat-error>
        </mat-form-field>
      </div>

      <div class="col-span-4">
        <mat-label> {{ "employee.postal_code" | translate }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="postalCode"
            [ngClass]="{ 'is-invalid': submitted && f['postalCode'].errors }"
          />
          <mat-error
            *ngIf="submitted && f['postalCode'].errors?.['required']"
            >{{ "error.required" | translate }}</mat-error
          >
        </mat-form-field>
      </div>
      <div class="col-span-4">
        <mat-label>{{ "employee.address" | translate }}</mat-label>

        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            formControlName="address"
            [ngClass]="{ 'is-invalid': submitted && f['address'].errors }"
          />
          <mat-error *ngIf="submitted && f['address'].errors?.['required']">{{
            "error.required" | translate
          }}</mat-error>
        </mat-form-field>
      </div>

      <div formGroupName="emergencyContact" class="col-span-12">
        <div class="col-span-12">
          <legend>{{ "employee.emergency_contact" | translate }}</legend>
        </div>
        <div class="user-group grid grid-cols-12 border-t-2 pt-4 px-6 gap-8">
          <div class="col-span-4">
            <mat-label>{{ "employee.ec_name" | translate }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <input matInput formControlName="name" />
            </mat-form-field>
          </div>

          <div class="col-span-4">
            <mat-label>{{ "employee.ec_mobile" | translate }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <input matInput formControlName="mobile" />
            </mat-form-field>
          </div>
          <div class="col-span-4">
            <mat-label>{{ "employee.ec_email" | translate }}</mat-label>

            <mat-form-field appearance="outline" class="w-full">
              <input matInput formControlName="email" />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="w-full flex items-center justify-end mb-2">
        <button mat-raised-button color="primary" type="submit" class="w-60">
          {{
            isEditMode
              ? ("button.update" | translate)
              : ("button.submit" | translate)
          }}
        </button>
      </div>
    </div>
  </div>
</form>
